module.exports = __webpack_public_path__ + "img/Synchronization.d5464d2a.svg";